export const systemConstants = {
  CUSTOMER_MODEL_UPDATE: "CUSTOMER_MODEL_UPDATE",
  CUSTOMER_MODEL_DELETE: "CUSTOMER_MODEL_DELETE",

  USER_MODEL_UPDATE: "USER_MODEL_UPDATE",
  USER_MODEL_DELETE: "USER_MODEL_DELETE",

  CATALOGUE_SELECTION_OPEN: "CATALOGUE_SELECTION_OPEN",
  CATALOGUE_SELECTION_CLOSE: "CATALOGUE_SELECTION_CLOSE",

  HIDE_PRICE: "SYSTEM_HIDE_PRICE",
  TAB: "SYSTEM_TAB",

  SET_OFFSET_TOP: "SET_OFFSET_TOP",
  MINIMIZE_UI: "MINIMIZE_UI",
  TOGGLE_MOBILE_NAV_BUTTON: "TOGGLE_MOBILE_NAV_BUTTON",
};
